// extracted by mini-css-extract-plugin
export default {"root":"Language_root__KNIgd","button":"Language_button__6Yuv4","icon":"Language_icon__Hfaj1","active":"Language_active__LG8Op"};